
export default [
    {
        path: "/register",
        name: "register",
        component: () => import(/* webpackChunkName: "register" */ "../views/semester/Register.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/semester/view-pdf/:pdf_name",
        name: "view_semester_pdf",
        props: true,
        component: () => import(/* webpackChunkName: "view_pdf" */ "../views/semester/ViewSemesterPDF.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/membership",
        name: "membership",
        component: () => import(/* webpackChunkName: "membership_form" */ "../views/registration/MembershipForm.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/register/:id",
        props: true,
        name: "register_student",
        component: () => import(/* webpackChunkName: "register_student" */ "../views/semester/RegisterSingleStudent.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/directory",
        name: "directory",
        component: () => import(/* webpackChunkName: "member_directory" */ "../views/directory/Directory.vue"),
        meta: { requiresAuth: true }
    }
]